/**
 * @generated SignedSource<<bcf6371051972dda4e73703ef8d6345b>>
 * @relayHash 44fbfb9d6df590a6ee4e002cd5037220
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01

import type { ConcreteRequest } from 'relay-runtime';
export type graphqlHelpersFetchMediaTokenWithMediaItemsQuery$variables = {
  cloudId: string;
  contentId?: string | null;
  missingContentId?: boolean | null;
  status?: ReadonlyArray<string | null> | null;
};
export type graphqlHelpersFetchMediaTokenWithMediaItemsQuery$data = {
  readonly content?: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaItems: ReadonlyArray<{
            readonly details: {
              readonly abuseClassification: {
                readonly classification: string | null;
                readonly confidence: string | null;
              } | null;
              readonly artifactsList: ReadonlyArray<{
                readonly createdAt: AGG$Long | null;
                readonly mimeType: string | null;
                readonly name: string;
                readonly processingStatus: string | null;
                readonly size: AGG$Long | null;
                readonly url: string | null;
              }> | null;
              readonly createdAt: AGG$Long | null;
              readonly failReason: string | null;
              readonly mediaMetadata: {
                readonly duration: number | null;
              } | null;
              readonly mediaType: string | null;
              readonly mimeType: string | null;
              readonly name: string | null;
              readonly preview: {
                readonly cdnUrl: string | null;
              } | null;
              readonly processingStatus: string | null;
              readonly representations: {
                readonly image: {
                  readonly _empty: boolean | null;
                } | null;
              } | null;
              readonly size: AGG$Long | null;
            };
            readonly id: string;
            readonly type: string;
          } | null> | null;
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
  readonly mediaConfiguration: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
};
export type graphqlHelpersFetchMediaTokenWithMediaItemsQuery = {
  response: graphqlHelpersFetchMediaTokenWithMediaItemsQuery$data;
  variables: graphqlHelpersFetchMediaTokenWithMediaItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "missingContentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "size"
},
v7 = {
  "kind": "ScalarField",
  "name": "mimeType"
},
v8 = {
  "kind": "ScalarField",
  "name": "processingStatus"
},
v9 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v10 = [
  {
    "condition": "missingContentId",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContentBody",
                    "kind": "LinkedField",
                    "name": "atlas_doc_format",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "EmbeddedMediaToken",
                        "kind": "LinkedField",
                        "name": "mediaToken",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "token"
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                          }
                        ],
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "mediaItems",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          },
                          {
                            "concreteType": "MediaFileDetails",
                            "kind": "LinkedField",
                            "name": "details",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mediaType"
                              },
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "failReason"
                              },
                              (v9/*: any*/),
                              {
                                "concreteType": "MediaFilePreview",
                                "kind": "LinkedField",
                                "name": "preview",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "cdnUrl"
                                  }
                                ]
                              },
                              {
                                "concreteType": "MediaFileArtifact",
                                "kind": "LinkedField",
                                "name": "artifactsList",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  (v7/*: any*/),
                                  (v5/*: any*/),
                                  (v8/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ]
                              },
                              {
                                "concreteType": "MediaFileRepresentations",
                                "kind": "LinkedField",
                                "name": "representations",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "MediaImageRepresentation",
                                    "kind": "LinkedField",
                                    "name": "image",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "_empty"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "MediaFileMetadata",
                                "kind": "LinkedField",
                                "name": "mediaMetadata",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "duration"
                                  }
                                ]
                              },
                              {
                                "concreteType": "MediaFileAbuseClassification",
                                "kind": "LinkedField",
                                "name": "abuseClassification",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "classification"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "MediaConfiguration",
    "kind": "LinkedField",
    "name": "mediaConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "clientId"
      },
      {
        "kind": "ScalarField",
        "name": "fileStoreUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
    "selections": (v10/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "44fbfb9d6df590a6ee4e002cd5037220",
    "id": "3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01",
    "metadata": {},
    "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
    "operationKind": "query",
    "text": "query graphqlHelpersFetchMediaTokenWithMediaItemsQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token},mediaItems(cloudId:$cloudId){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
  }
};
})();

(node as any).hash = "c03e617139295e9107b3907ee1a06cb3";

export default node;
